
import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { Urls } from '@/apiConnection/urls';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { ProductTypeFormComponent } from '../product-type-form/product-type-form.component';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './product-type-list.page.html',
  styleUrl: './product-type-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class ProductTypeListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  public url = Urls.urls.productTypes;

  public headers = [
    { name: 'NOMBRE', key: 'name' },
    { name: 'ALÉRGENOS', key: 'has_allergens', type: 'boolean' },
    { name: 'CONTROL STOCK', key: 'stock_control', type: 'boolean' },
  ];

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(ProductTypeFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'tipo de producto';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
